// AUTO-GENERATED by scripts/generate-build-info.mjs — do not edit by hand.
export const buildInfo = {
  version: '1.0.0',
  commit: '40df667',
  branch: 'unknown',
  buildTime: '2026-11-04T23:20:42.301Z',
};
